import React from 'react'

function TIFFFIleIcon() {
  return (
    <svg
      width='50'
      height='66'
      viewBox='0 0 50 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H33.547L39.9573 5.98291L50 14.7436V57.812C50 62.2302 46.4183 65.812 42 65.812H8C3.58172 65.812 0 62.2302 0 57.812V8Z'
        fill='#E45453'
      />
      <path
        d='M33.3923 10.5228L33.547 0L50 14.7436L37.3406 14.5813C35.1287 14.5529 33.3597 12.7346 33.3923 10.5228Z'
        fill='#AA3D3C'
      />
      <path
        d='M16.736 26.8V28.528H13.456V38H11.616V28.528H8.336V26.8H16.736ZM18.5178 38V26.8H20.3418V38H18.5178ZM29.6533 28.528H25.0293V31.696H29.2373V33.392H25.0293V38H23.2053V26.8H29.6533V28.528ZM38.1064 28.528H33.4824V31.696H37.6904V33.392H33.4824V38H31.6584V26.8H38.1064V28.528Z'
        fill='white'
      />
    </svg>
  )
}

export default TIFFFIleIcon
